import { type WorkoutSetType } from "api-client";
import { Icon } from "icons";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "ui";

import { WorkoutSetLabel } from "src/components/WorkoutSetLabel";
import { WorkoutSetTypeDropdownItem } from "src/components/WorkoutSetTypeDropdownItem";
import { useUpdateSetType } from "src/workouts/useUpdateSetType";
import { WORKOUT_SET_TYPE_OPTIONS } from "src/workouts/workoutSetType";

interface WorkoutSetTypeDropdownProps {
  setId: string;
  type: WorkoutSetType | null | undefined;
  setNumber: number;
}

export function WorkoutSetTypeDropdown(props: WorkoutSetTypeDropdownProps) {
  const updateSetType = useUpdateSetType();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="group/set-type-trigger h-7 gap-2 border border-transparent px-2 font-normal transition-none group-hover/table-row:border-border data-[state=open]:border-border"
        >
          <span className="min-w-3.5 text-center">
            <WorkoutSetLabel type={props.type} setNumber={props.setNumber} />
          </span>
          <Icon
            name="tabler-chevron-down"
            className="size-3 invisible text-muted-foreground group-hover/table-row:visible group-data-[state=open]/set-type-trigger:visible"
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {WORKOUT_SET_TYPE_OPTIONS.map((option) => {
          return (
            <WorkoutSetTypeDropdownItem
              key={option.letter}
              option={option}
              selected={option.type === (props.type ?? null)}
              onSelect={() => {
                updateSetType.perform(props.setId, option.type);
              }}
            />
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
